const WHISTLE_FAVICONS = {
  appleTouchIcon: "/apple-touch-icon.png",
  favicon32: "/favicon-32x32.png",
  favicon16: "/favicon-16x16.png",
  // Bug #189562 (PR review): moved off "/favicon.ico" so that path can be a
  // permanent blank placeholder (browsers auto-request it directly, bypassing
  // <link> tags entirely) — see public/index.html and whitelabelMixin.js's
  // matching default, which also had to move to stay in sync.
  favicon: "/whistle-favicon.ico",
  manifest: "/site.webmanifest",
};

const PERFORMX_FAVICONS = {
  appleTouchIcon: "/performx-apple-touch-icon.png",
  favicon32: "/performx-favicon-32x32.png",
  favicon16: "/performx-favicon-16x16.png",
  favicon: "/performx-favicon.png",
  manifest: "/performx-site.webmanifest",
};

function setLinkHref(selector, href) {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute("href", href);
  }
}

function upsertIconLink({ rel, type, sizes, href }) {
  let selector = `link[rel="${rel}"]`;
  if (sizes) {
    selector += `[sizes="${sizes}"]`;
  } else {
    selector += ":not([sizes])";
  }

  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (type) el.setAttribute("type", type);
    if (sizes) el.setAttribute("sizes", sizes);
    document.head.appendChild(el);
  }

  el.setAttribute("href", href);
}

function applyTenantIcons(url) {
  const selectors = [
    'link[rel="apple-touch-icon"]',
    'link[rel="icon"][sizes="32x32"]',
    'link[rel="icon"][sizes="16x16"]',
    'link[rel="icon"]:not([sizes])',
  ];
  for (const selector of selectors) {
    const el = document.querySelector(selector);
    if (el) {
      el.setAttribute("href", url);
    }
  }
}

// Tracks the most recent invocation so a stale in-flight preload can detect it's been superseded.
let currentGeneration = 0;

/**
 * Swap document favicons / web manifest between Whistle and PerformX branding.
 * @param {boolean} usePerformx - when true, use PerformX assets
 * @param {string|null} tenantFaviconUrl - optional https:// URL; overrides icon links (not manifest)
 */
export function applyBrandFavicons(usePerformx, tenantFaviconUrl = null) {
  const generation = ++currentGeneration;

  if (typeof document === "undefined") return;

  const brand = usePerformx ? PERFORMX_FAVICONS : WHISTLE_FAVICONS;

  // Static brand favicons apply first, unconditionally, so there is always a safe default.
  setLinkHref('link[rel="apple-touch-icon"]', brand.appleTouchIcon);
  setLinkHref('link[rel="icon"][sizes="32x32"]', brand.favicon32);
  setLinkHref('link[rel="icon"][sizes="16x16"]', brand.favicon16);
  // Browsers often request a generic favicon; keep an unsized icon link in sync.
  upsertIconLink({
    rel: "icon",
    type: usePerformx ? "image/png" : "image/x-icon",
    href: brand.favicon,
  });
  // Manifest always follows brand, never the tenant URL.
  setLinkHref('link[rel="manifest"]', brand.manifest);

  const validTenantUrl =
    tenantFaviconUrl && tenantFaviconUrl.toLowerCase().startsWith("https://")
      ? tenantFaviconUrl
      : null;

  // <link rel="icon"> never fires load/error in Chromium, so an Image preload is the only reliable signal.
  if (validTenantUrl && typeof Image !== "undefined") {
    const img = new Image();
    img.onload = () => {
      if (generation === currentGeneration) applyTenantIcons(validTenantUrl);
    };
    img.onerror = () => {};
    img.src = validTenantUrl;
  }
}

export const __testing = {
  WHISTLE_FAVICONS,
  PERFORMX_FAVICONS,
};
